module.exports = __webpack_public_path__ + "media/images/coins-09c3be9d59ca899eb833c687895e16d3.svg";